import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import ChevronRightIcon from '@nokia-csf-uxr/ccfk-assets/ChevronRightIcon';
import ChevronLeftIcon from '@nokia-csf-uxr/ccfk-assets/ChevronLeftIcon';
import styled from './styles';

export interface LinkSeparatorProps extends React.ComponentPropsWithRef<'div'> {
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * Single LinkSeparator component.
 * All props will be provided to the root element. */
const LinkSeparator = React.forwardRef<HTMLElement, LinkSeparatorProps>((props: LinkSeparatorProps, ref) =>
  getContext(({ RTL, theme }) => {
    const {
      theme: themeProp,
      ...otherProps
    } = props;
    const resolvedTheme = _merge({}, theme ? theme.BREADCRUMBS : {}, themeProp);
    return (
      <styled.LinkSeparator {...otherProps} ref={ref}>
        {!RTL ? <ChevronRightIcon color={resolvedTheme.separatorColor} /> : <ChevronLeftIcon color={resolvedTheme.separatorColor} />}
      </styled.LinkSeparator>
    );
  }));

LinkSeparator.defaultProps = {
  theme: {},
};
LinkSeparator.displayName = 'LinkSeparator';
export default LinkSeparator;
